/**
 * Add Manufacturer Form Schema
 * 
 * Simple schema - user only enters the name.
 * manufacturerNumber is auto-generated by the backend.
 * 
 * Form metadata (name, title, description) is loaded from form.yml
 */

import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

// Load form configuration from YAML
const formConfig = FormConfigLoader.loadFormConfig(formYaml)

// ============================================================================
// Export Form Metadata from YAML
// ============================================================================

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

// ============================================================================
// Form Schema (What user fills in = what gets sent to API)
// ============================================================================

export const AddManufacturerFormSchema = z.object({
  manufacturerNumber: z.number().optional(), // Business key for edit mode
  manufacturerName: z
    .string()
    .min(3, 'Name must be at least 3 characters')
    .max(60, 'Name cannot exceed 60 characters'),
})

export type AddManufacturerFormData = z.infer<typeof AddManufacturerFormSchema>

/**
 * Transform form data to API request format.
 * No transformation needed - API only requires the name.
 */
export function transformToApiRequest(formData: AddManufacturerFormData) {
  return {
    manufacturerNumber: formData.manufacturerNumber, // Business key for upsert
    manufacturerName: formData.manufacturerName,
  }
}
